const Privacy = () => (
  <div className="min-h-screen bg-background text-foreground">
    <div className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-muted-foreground mb-8">Last updated: March 24, 2026</p>

      <div className="space-y-6 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold mb-2">1. Information We Collect</h2>
          <p>Command X collects information you provide directly, such as your name, email address, company name, and billing information when you create an account. We also collect data related to your use of the platform, including project details, financial records, invoices, and documents you upload.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">2. How We Use Your Information</h2>
          <p>We use your information to provide, maintain, and improve Command X services, process transactions, send service-related communications, and comply with legal obligations. We do not sell your personal information to third parties.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">3. Third-Party Integrations</h2>
          <p>Command X integrates with third-party services such as QuickBooks Online. When you connect these services, we access data from those platforms solely to provide the features you requested (e.g., importing invoices, customers, and estimates). We perform read-only access and do not modify your data in third-party systems unless explicitly authorized by you.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">4. Data Storage & Security</h2>
          <p>Your data is stored securely using industry-standard encryption at rest and in transit. We use secure cloud infrastructure and follow best practices for access controls, authentication, and audit logging. OAuth tokens for third-party integrations are encrypted before storage.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">5. Data Sharing</h2>
          <p>We do not share your personal or business data with third parties except as necessary to provide the service (e.g., cloud hosting providers), comply with legal requirements, or with your explicit consent.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">6. Cookies</h2>
          <p>Command X uses essential cookies for authentication and session management. We do not use third-party advertising cookies.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">7. Your Rights</h2>
          <p>You may request access to, correction of, or deletion of your personal data at any time by contacting us. You may also disconnect third-party integrations at any time through your account settings.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">8. Contact Us</h2>
          <p>If you have questions about this Privacy Policy, please contact us at <span className="font-medium">privacy@commandx.com</span>.</p>
        </section>
      </div>

      <div className="mt-12 pt-6 border-t border-border text-xs text-muted-foreground">
        © {new Date().getFullYear()} Command X. All rights reserved.
      </div>
    </div>
  </div>
);

export default Privacy;
